import React from 'react'
import useGithubLanguages from '../../../hooks/useGithubLanguages'

function LanguagesBar({owner,repo}) {
    const {languages} = useGithubLanguages(owner,repo);
    const top = languages.slice(0,6)
  return (<div className='grid grid-cols-2 gap-y-2 py-2'>
    {
    top.map((lang)=>(
        <div>
            <h1 className='text-xs text-black/80'>
                {lang.name}
            </h1>
            <div className={`h-[3px] rounded-full my-1`} 
            style={{
                width:`${lang.pct}%`,
                background:lang.color
            }}
            />
        </div>
    ))
      }
  </div>
  )
}

export default LanguagesBar